import EnvUtils from "./EnvUtils";

export default class StripeUtils {
  static RESULT_PAID = "paid"
  static RESULT_TRIAL = "trial"
  static RESULT_UNKNOWN = "unknown"
  static RESULT_FAIL = "fail"
  static RESULT_ACTION = "action"

  static getSubscribtionResult(data) {
    let invoiceStatus = data.InvoiceStatus
    let piStatus = data.PIStatus
    let status = data.Status
    if (status === 'active' && invoiceStatus === 'paid' && piStatus === 'succeeded') {
      return this.RESULT_PAID
    }
    if (status === 'trialing' && invoiceStatus === 'paid') {
      return this.RESULT_TRIAL
    }
    if (status === 'incomplete' && invoiceStatus === 'open' && piStatus === 'requires_payment_method') {
      return this.RESULT_FAIL
    }
    if (status === 'incomplete' && invoiceStatus === 'open' && piStatus === 'requires_action') {
      return this.RESULT_ACTION
    }
    return this.RESULT_UNKNOWN
  }

  static getStripe() {
    return Stripe(this.getStripeKey()); // eslint-disable-line
  }

  static getStripeKey() {
      if (EnvUtils.isdev()) {
        return "pk_test_MFpfdwcAtSdHvvOzlB2ycfTu00JMBwYVKS" // DEV
      }
      return "pk_live_YJUybmgzBPvIrt5JJYkw8vFv00WPSUWTkp" // PROD
    }
}
